module.exports = __webpack_public_path__ + "img/IMG_2122.86f5a626.jpg";